import { WoltLogo, colors, cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

export const ImagesContainer = styled.div`
  display: flex;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  margin: 0 4px;
  border-radius: 8px;
  border: 1px solid ${cssThemedValue('borderPrimary')};
  background-color: ${cssThemedValue({ light: colors.pepper8, dark: colors.salt12 })};
  overflow: hidden;
`;

export const Thumbnail = styled.img`
  width: 36px;
  height: 36px;
  object-fit: cover;
`;

export const PlaceholderImage = styled(WoltLogo)`
  width: 26px;
  fill: ${cssThemedValue('textTertiary')};
`;

export const RowImages = ({ images }: { images: string }) => (
  <ImagesContainer>
    {images ? (
      images.split(',\n').map(preview => (
        <ImageContainer>
          <Thumbnail src={preview} />
        </ImageContainer>
      ))
    ) : (
      <ImageContainer>
        <PlaceholderImage />
      </ImageContainer>
    )}
  </ImagesContainer>
);
